import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ItemPage } from '../item/item';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController) {
    
  }
  gotoItem(arg) {
    this.navCtrl.push(ItemPage,{"ItemNumber": arg});
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts